import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import CommonPatientInfo from '../../components/CommonPatientInfo';

import { SurveyDialogProps, TPAINAD_K_noneDefaultValues } from '../../type';
import { updatePAINAD_K_none } from 'apis/survey';
import PAINADK from './PAINADK';
import CPOT_K from './CPOT_K';
import Algoplus from './Algoplus';

const PAINAD_K_non = (
  props: SurveyDialogProps<TPAINAD_K_noneDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    patientInfo,
    nurseName,
    user_id,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TPAINAD_K_noneDefaultValues) => {
    const {} = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      contents: {
        ...data,
      },
    };
    updatePAINAD_K_none(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        PAINAD-K, CPOT-K, Algoplus (Non-Communicative patients)
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <PAINADK {...formProps} />
      <CPOT_K {...formProps} />
      <Algoplus {...formProps} />
    </MuiDialog.SurveyForm>
  );
};

export default PAINAD_K_non;
